import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Box, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './tldPromotionBoxes.scss';
const DOMAIN_PRICE_KEY = 'domain_search_gate.domain_gate.tld_section.domain_price';
export const PerceptionTldPrice = _ref => {
  let {
    pricing,
    row
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    t: tSuite
  } = DomainSearchSuiteModule.internals.useTranslations();
  const price = pricing[row.priceFrom];
  const strikethrough = pricing[row.strikethroughFrom];
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    verticalAlign: "middle",
    className: s.price,
    marginTop: "auto"
  }, strikethrough && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true,
    className: s.strikethroughPrice
  }, t(DOMAIN_PRICE_KEY, {
    domainPrice: strikethrough
  })), price && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    className: s.reframedPrice
  }, row.perYear ? t(DOMAIN_PRICE_KEY, {
    domainPrice: price
  }) : price), /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(Box, {
      padding: "SP3 SP4"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin",
      light: true
    }, tSuite(row.tooltipKey, {
      price: pricing.renewalPrice,
      renewalPrice: pricing.renewalPrice
    })))
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon,
    "data-hook": "perception-tld-info-icon"
  }))));
};
//# sourceMappingURL=PerceptionTldPrice.js.map